export default __webpack_public_path__ + "static/media/logo.760df7b9.svg";